<template>
    <svg 
        :width="width" 
        :height="height" 
        viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_10949_82787)">
            <circle cx="9.99976" cy="16" r="2.00562" :stroke="iconColor" stroke-width="2"/>
            <path d="M5 11.9707V5.99904C5 3.23585 7.24 0.99585 10.0032 0.99585C12.7664 0.99585 15.0064 3.23585 15.0064 5.99904V10.9733" :stroke="iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.97239 11.9922L4.49199 11.9922C3.1157 11.9922 2 10.8765 2 9.5002C2 8.12391 3.1157 7.00821 4.49199 7.00821L4.97239 7.00821" :stroke="iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14.0076 12.0034L15.4953 12.0034C16.8765 12.0034 17.9961 10.8838 17.9961 9.50263C17.9961 8.12149 16.8765 7.00185 15.4953 7.00185L14.0352 7.00185" :stroke="iconColor" stroke-width="2"/>
            <path d="M15.0031 11.7447C15.0031 13.6704 13.7238 15.2974 11.9688 15.8223" :stroke="iconColor" stroke-width="2"/>
        </g>
        <defs>
            <clipPath id="clip0_10949_82787">
                <rect width="20" height="20" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>